import { Trash01 } from "@untitledui/icons";
import {
	FeatureModal,
	FeatureModalSize,
	FeatureModalTone,
} from "@/components/Organisms/FeatureModal/FeatureModal";
import { useAppTranslation } from "@/hooks/use-app-translation";
import type { AdminFormI18nPaths } from "../../admin-form-editor-i18n-paths";

export interface DeleteFormRuleConfirmProps {
	isOpen: boolean;
	ruleName: string;
	paths: AdminFormI18nPaths;
	onConfirm: () => void;
	onCancel: () => void;
}

/**
 * Confirmation for removing a form rule from the in-memory editor draft.
 * Deletion only takes effect when the parent saves the form.
 */
export function DeleteFormRuleConfirm({
	isOpen,
	ruleName,
	paths,
	onConfirm,
	onCancel,
}: DeleteFormRuleConfirmProps) {
	const { t } = useAppTranslation();

	return (
		<FeatureModal
			isOpen={isOpen}
			onOpenChange={(open) => {
				if (!open) onCancel();
			}}
			size={FeatureModalSize.Md}
			tone={FeatureModalTone.Error}
			icon={Trash01}
			title={t(paths.formRules.delete.title)}
			description={t(paths.formRules.delete.body, { name: ruleName })}
			secondaryLabel={t(paths.formRules.delete.cancel)}
			primaryLabel={t(paths.formRules.delete.confirm)}
			primaryColor="primary-destructive"
			onPrimary={onConfirm}
			closeAriaLabel={t(paths.formRules.modal.close)}
			data-testid="delete-form-rule-confirm"
		/>
	);
}
